import React from "react";
import PropTypes from 'prop-types';
import { testAttributes } from './Constants';

import './scss/title.scss';
import './scss/disclosure.scss';
import './scss/editorial.scss';
import './scss/trustpilot.scss';

const MortgageRate = ({ content = null }) => (
    <app-mortgage-rates data-testid={testAttributes.MORTGAGE_RATE_PAGE}>
        <div className="QLD_ROOT">
            <div className="qld-grid">
                {content}
            </div>
        </div>
    </app-mortgage-rates>
);

MortgageRate.propTypes = {
    /** Mortgage Rates page content. Array of JSX expected */
    content: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object),
        PropTypes.object,
        PropTypes.string
    ]))
};

export default MortgageRate;